<template>
  <div
    id="app"
    class="app-container"
  >
    <Startup />
    <InfoBar />
  </div>
</template>

<script>
import Startup from '@/components/Startup';
import InfoBar from '@/components/InfoBar';

export default {
  name: 'App',
  components: {
    Startup,
    InfoBar
  },
  created() {
    // TODO - REMOVE THIS AS IT CLEANS UP OLD LOCAL STORAGE SETTING
    localStorage.removeItem('screenName');

    let bookieid = this.getParameterByName('bookieId');

    if (bookieid) {
      localStorage.setItem('bookieId', bookieid);
    } else {
      bookieid = localStorage.getItem('bookieId');
    }
    let screenname = this.getParameterByName('screenName');

    if (screenname !== '' && screenname !== null) {
      sessionStorage.setItem('screenName', screenname);
    } else {
      screenname = sessionStorage.getItem('screenName');
    }

    this.$store.commit('setBookieId', bookieid);
    this.$store.commit('setScreenName', screenname);
  },
  methods: {
    getParameterByName: function(name, url) {
      if (!url) url = window.location.href;

      name = name.replace(/[[\]]/g, '\\$&');

      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      const results = regex.exec(url);

      if (!results) return null;
      if (!results[2]) return '';

      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }
};
</script>

<style scoped>
  body {
    background-color: #000;
  }
</style>



// WEBPACK FOOTER //
// App.vue?bc6b9de8